/**
 * Recommendation-step light primitive: the gap-analysis section — the read-only `GuideFindings` built
 * from the deep-dive answers (the exposure-by-lane bars, the signals-logged donut, and the ranked
 * Recommendations list) — inside its `Block`. This matches the UAT recommendation view exactly: the
 * section is a clean read-only analysis, NOT a cluster of editable gap-row textareas.
 *
 * The heavy report editor lives in the lazily-loaded `./reportEditor`, and the step's Comments section
 * reuses the shared `comments` primitive, so neither is re-implemented here — keeping this module free
 * of the report/PDF export subsystem.
 */
import { deepDiveScoring } from '../behaviors';
import { Block } from '../../components/ui/primitives';
import { asIconName } from '../../components/ui/Icon';
import { sectionHeadings } from '../../config/sectionHeadings';
import { GuideFindings } from '../../components/steps/GuideFindings';
import type { PrimitiveProps } from './registry';

export function GapAnalysis({ ctx, config }: PrimitiveProps): JSX.Element {
  const analysis = deepDiveScoring(ctx.state);
  const h = sectionHeadings('recommendation');
  return (
    <Block
      icon={asIconName(config?.icon, 'table')}
      title={(config?.title as string) || h.gap?.title || ''}
      lead={(config?.lead as string) || h.gap?.lead}
      presenting={ctx.presenting}
    >
      <GuideFindings analysis={analysis} presenting={ctx.presenting} />
    </Block>
  );
}
